<template>
  <div class="layout-page">
    <div style="overflow: auto">
      <div class="left-menu" :class="{ open }">
        <div class="open-container" :class="{ open }">
          <i class="fa fa-bars" aria-hidden="true" @click="switchMenu"></i>
        </div>
        <template v-for="item in leftMenuList">
          <el-tooltip
            popper-class="custom-poper"
            v-if="!item.menu"
            :key="item.id"
            :content="item.text"
            effect="light"
            :disabled="open"
            placement="right"
          >
            <div
              class="menu-item"
              :key="item.id"
              @click="select(item)"
              :class="{ active: active === item.id }"
            >
              <div class="icon-img" :class="{ [item.index]: true }"></div>
              <div class="text">{{ item.text }}</div>
            </div>
          </el-tooltip>
          <!-- <menu-item :disabled="false" @itemClick="select" :key="item.id" v-if="item.id === 'bulk_schedule'"
                     :menu-list="bulkList">
            <div class="menu-item" @click="select(item)">
              <div class="icon-img" :class="{[item.index]:true}"></div>
              <div class="text">{{item.text}}</div>
            </div>
          </menu-item> -->
          <menu-item
            :disabled="open"
            @itemClick="select"
            :key="item.id"
            v-if="item.id === 'account'"
            :menu-list="accountList"
          >
            <div class="menu-item" @click="select(item)">
              <div class="icon-img" :class="{ [item.index]: true }"></div>
              <div class="text">{{ item.text }}</div>
            </div>
          </menu-item>
          <menu-item
            :disabled="open"
            @itemClick="select"
            :key="item.id"
            v-if="item.id === 'settings'"
            :menu-list="settingList"
          >
            <div class="menu-item" @click="select(item)">
              <div class="icon-img" :class="{ [item.index]: true }"></div>
              <div class="text">{{ item.text }}</div>
            </div>
          </menu-item>
        </template>
        <div style="flex: 1"></div>
        <upload-status :open="open" class="upload-icon"></upload-status>
        <div class="download-container">
          <div class="image ios" @click="iosClick()"></div>
        </div>
        <div class="download-container" style="margin-bottom: 15px">
          <div class="image android" @click="androidClick()"></div>
        </div>
      </div>
    </div>
    <div class="right-main-container">
      <router-view />
    </div>
  </div>
</template>
<style>
.custom-poper {
  border: 1px solid rgb(230, 230, 230) !important;
}
</style>
<style lang="less" scoped>
@import "../../assets/style/theme";

.layout-page {
  height: 100vh;
  max-width: 100vw;
  display: flex;
  position: relative;

  .left-menu {
    min-height: 800px;
    height: 100%;
    width: 90px;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #eceff1;
    overflow-x: hidden;

    .open-container {
      padding: 30px;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        color: #000;
        font-size: 18px;
        cursor: pointer;
      }
    }

    .download-container {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 54px;

      .image {
        width: 23px;
        height: 23px;
        background-size: cover;
        cursor: pointer;

        &.ios {
          background-image: url("../../../public/images/common/ios@3x.png");

          &:hover {
            opacity: 0.7;
          }
        }

        &.android {
          background-image: url("../../../public/images/common/android@3x.png");

          &:hover {
            opacity: 0.7;
          }
        }
      }
    }

    &.open {
      width: 190px;

      .menu-item {
        justify-content: flex-start;
        padding-left: 20px;

        .text {
          display: block;
          white-space: pre-line;
        }
      }

      .open-container {
        justify-content: flex-start;
        padding-left: 23px;
      }

      .download-container {
        .image {
          width: 162px;
          height: 44px;

          &.ios {
            background-image: url("../../../public/images/common/download_ios_n@3x.png");

            &:hover {
              background-image: url("../../../public/images/common/download_ios_s@3x.png");
            }
          }

          &.android {
            background-image: url("../../../public/images/common/downdoad_android_n@3x.png");

            &:hover {
              background-image: url("../../../public/images/common/downdoad_android_s@3x.png");
            }
          }
        }
      }

      .upload-icon {
        margin-left: 20px;
        margin-bottom: 16px;
      }
    }

    .menu-item {
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      cursor: pointer;

      .icon-img {
        height: 24px;
        width: 24px;
        background-size: contain;

        &.schedule-posts {
          background-image: url("../../../public/images/menu/M_Computer@3x.png");
        }

        &.drag-drop {
          background-image: url("../../../public/images/menu/M_D&D@3x.png");
        }

        &.search-repost {
          background-image: url("../../../public/images/menu/M_S&R@3x.png");
        }

        &.bulk-schedule {
          background-image: url("../../../public/images/menu/M_Bulk@3x.png");
        }

        &.apphi-library {
          background-image: url("../../../public/images/menu/M_MediaL@3x.png");
        }

        &.my-plan {
          background-image: url("../../../public/images/menu/M_MyPlan@3x.png");
        }

        &.account-setting {
          background-image: url("../../../public/images/menu/M_Setting@3x.png");
        }
      }

      .text {
        font-size: 14px;
        margin-left: 12px;
        font-weight: 500;
        line-height: 1.3;
        display: none;
      }

      &.active,
      &:hover {
        color: @theme-color;

        .schedule-posts {
          background-image: url("../../../public/images/menu/S_Computer@3x.png");
        }

        .drag-drop {
          background-image: url("../../../public/images/menu/S_D&D@3x.png");
        }

        .search-repost {
          background-image: url("../../../public/images/menu/S_S&R@3x.png");
        }

        .bulk-schedule {
          background-image: url("../../../public/images/menu/S_Bulk@3x.png");
        }

        .apphi-library {
          background-image: url("../../../public/images/menu/S_MediaL@3x.png");
        }

        .my-plan {
          background-image: url("../../../public/images/menu/S_MyPlan@3x.png");
        }

        .account-setting {
          background-image: url("../../../public/images/menu/S_Setting@3x.png");
        }
      }
    }

    .upload-icon {
      margin-left: 25px;
      margin-bottom: 16px;
    }
  }

  .right-main-container {
    flex: 1;
    overflow: auto;
  }

  .el-menu-vertical {
    min-height: 100vh;

    .open-container {
      padding: 30px 0;
      text-align: center;
      border-right: 3px solid transparent;

      i {
        color: #000;
        font-size: 18px;
        cursor: pointer;
      }

      &.open {
        text-align: left;
        padding-left: 25px;
      }
    }

    .el-menu-item,
    .el-submenu__title {
      .icon-img {
        &.schedule-posts {
          background-image: url("../../../public/images/menu/M_Computer@3x.png");
        }

        &.drag-drop {
          background-image: url("../../../public/images/menu/M_D&D@3x.png");
        }

        &.search-repost {
          background-image: url("../../../public/images/menu/M_S&R@3x.png");
        }

        &.bulk-schedule {
          background-image: url("../../../public/images/menu/M_Bulk@3x.png");
        }

        &.apphi-library {
          background-image: url("../../../public/images/menu/M_MediaL@3x.png");
        }

        &.my-plan {
          background-image: url("../../../public/images/menu/M_MyPlan@3x.png");
        }

        &.account-setting {
          background-image: url("../../../public/images/menu/M_Setting@3x.png");
        }
      }

      &.is-active {
        .schedule-posts {
          background-image: url("../../../public/images/menu/S_Computer@3x.png");
        }

        .drag-drop {
          background-image: url("../../../public/images/menu/S_D&D@3x.png");
        }

        .search-repost {
          background-image: url("../../../public/images/menu/S_S&R@3x.png");
        }

        .bulk-schedule {
          background-image: url("../../../public/images/menu/S_Bulk@3x.png");
        }

        .apphi-library {
          background-image: url("../../../public/images/menu/S_MediaL@3x.png");
        }

        .my-plan {
          background-image: url("../../../public/images/menu/S_MyPlan@3x.png");
        }

        .account-setting {
          background-image: url("../../../public/images/menu/S_Setting@3x.png");
        }
      }
    }
  }
}
</style>
<script>
import { mapGetters } from "vuex";
import {
  MENU_OPEN,
  CURRENT_PUBLISHER_SIMPLE,
} from "../../store/mutation-types";
import MenuItem from "../../components/layout/MenuItem";
import UploadStatus from "../../components/layout/Upload";
import { validateCurrentPublisherStatus } from "../../service/publisher";
import _ from "lodash";
export default {
  name: "LayoutPage",
  components: { UploadStatus, MenuItem },
  computed: {
    ...mapGetters({
      menuOpen: MENU_OPEN,
      currentPublisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    open() {
      // 如果窄屏都是打开，则说明所有状态都是打开
      if (this.menuOpen === 1) {
        return true;
      }
      // 如果宽屏都是关闭，则说明所有状态都是关闭
      if (this.menuOpen === 2) {
        return false;
      }
      // 如果默认 则宽打开 窄关闭
      if (this.menuOpen === 0) {
        return this.pageLarge;
      }
    },
    leftMenuList() {
      const list = _.cloneDeep(this.menuList);
      if (this.currentPublisher === null) {
        return list;
      }
      if (this.currentPublisher.socialNetwork !== 1) {
        const ddIndex = list.findIndex((i) => i.id === "drag_drop");
        list.splice(ddIndex, 1);
      }
      return list;
    },
    instagram() {
      return this.currentPublisher.socialNetwork === 1;
    },
  },
  data() {
    const menuList = [
      {
        id: "schedule",
        index: "schedule-posts",
        route: { name: "SchedulePage" },
        text: "Schedule",
      },
      {
        id: "drag_drop",
        index: "drag-drop",
        route: { name: "SchedulePage", query: { type: "drag" } },
        text: `Drag & Drop \n Preview`,
      },
      {
        id: "library",
        index: "apphi-library",
        route: { name: "LibraryPage" },
        text: "Apphi Library",
      },
      {
        id: "bulk_schedule",
        index: "bulk-schedule",
        route: { name: "SchedulePage", query: { type: "bulk" } },
        text: "Bulk Schedule",
      },
      {
        id: "account",
        index: "my-plan",
        text: "Accounts",
        menu: true,
        route: { name: "AddInstagramPage" },
      },
      {
        id: "settings",
        index: "account-setting",
        text: "Setting",
        menu: true,
        route: { name: "SettingAccountPage" },
      },
    ];
    return {
      pageLarge: false,
      menuList,
      bulkList: [
        {
          id: "bulk-media",
          text: "Text With Media",
          route: {
            name: "SchedulePage",
            query: { type: "bulk", bulkType: "media" },
          },
        },
        {
          id: "bulk-text",
          text: "Text Only",
          route: {
            name: "SchedulePage",
            query: { type: "bulk", bulkType: "text" },
          },
        },
      ],
      accountList: [
        {
          id: "instagrams",
          text: "Added Social Account",
          route: { name: "AddInstagramPage" },
        },
        {
          id: "premium-instagrams",
          text: "Unlimited Schedules",
          route: { name: "UnlimitedAutopostPage" },
        },
        {
          id: "members",
          text: "Team Member",
          route: { name: "MemberPage" },
        },
        {
          id: "plans",
          text: "Upgrade Plan",
          route: { name: "UpgradePage" },
        },
        {
          id: "billing",
          text: "Payment",
          route: { name: "PaymentHistoryPage" },
        },
      ],
      settingList: [
        {
          id: "account",
          text: "Account",
          route: { name: "SettingAccountPage" },
        },
        {
          id: "default-time",
          text: "Default Post Time",
          route: { name: "SettingDefaultTimePage" },
        },
        {
          id: "default-caption-comment",
          text: "Default Caption or \n Comment",
          route: { name: "SettingDefaultCaptionPage" },
        },
        {
          id: "manager-caption-comment",
          text: "Manage Caption or \n Comment",
          route: { name: "SettingManagerCaptionPage" },
        },
        {
          id: "notifications",
          text: "Notifications",
          route: { name: "SettingNotificationsPage" },
        },
        {
          id: "logout",
          index: "logout",
          text: "Logout",
        },
      ],
      active: "", // 当前激活项目
    };
  },
  watch: {
    $route: {
      handler(val) {
        let page = val.path.split("/layout/")[1];
        if (this.$route.query.type === "drag") {
          page = "drag_drop";
        } else if (val.query.type === "repost") {
          page = "search_repost";
        } else if (val.query.type === "bulk") {
          page = "bulk_schedule";
        }
        this.active = page;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /**
     * 菜单点击事件
     */
    async select(item) {
      // 如果是非ins模式点击bulk无效，只有点击bulk子菜单才可以
      // if (!this.instagram && item.id === 'bulk_schedule') {
      //   return
      // }
      // 如果发现为二级菜单且为关闭状态则不进行跳转
      if (!this.open && item.menu) {
      } else {
        if (item.id !== "logout") {
          // 验证当前用户是否需要登录，如果需要登录则弹出提示
          if (!validateCurrentPublisherStatus()) {
            return;
          }
          this.$router.push(item.route);
        }
      }
    },
    iosClick() {
      window.open(
        "https://itunes.apple.com/us/app/apphi-scheduler-for-instagram/id1251406049?mt=8",
        "_blank"
      );
      this.value = false;
    },
    androidClick() {
      window.open("https://go.onelink.me/app/apphiwebforandroid", "_blank");
      this.value = false;
    },
    /**
     * 切换菜单打开收起
     */
    switchMenu() {
      // 宽屏点关闭
      if (this.pageLarge && this.open) {
        this.$store.commit(MENU_OPEN, 2);
        return;
      }
      // 窄屏点打开
      if (!this.pageLarge && !this.open) {
        this.$store.commit(MENU_OPEN, 1);
        return;
      }
      this.$store.commit(MENU_OPEN, 0);
    },
  },
  created() {
    // 判断如果当期那选中项
    window.onresize = () => {
      // 根据宽度自动折叠左侧菜单
      this.pageLarge = document.documentElement.clientWidth > 1100;
    };
  },
};
</script>
